import { Button, Modal, Typography } from 'antd';

const { Paragraph } = Typography;

type NewLayoutAnnouncementProps = {
  open: boolean;
  onEnable: () => void;
  onDismiss: () => void;
};

// Presents the new layout once. Closing it any way other than the primary button keeps the
// current layout, so it never changes the screen under the person without them asking.
export const NewLayoutAnnouncement = ({
  open,
  onEnable,
  onDismiss,
}: NewLayoutAnnouncementProps) => (
  <Modal
    centered
    destroyOnClose
    open={open}
    title="Conheça o novo layout"
    onCancel={onDismiss}
    footer={[
      <Button key="keep" onClick={onDismiss}>
        Continuar no atual
      </Button>,
      <Button key="enable" type="primary" onClick={onEnable}>
        Ativar novo layout
      </Button>,
    ]}
  >
    <Paragraph>
      Estamos renovando a navegação da plataforma. No novo layout, o logo fica no topo do menu
      lateral e o cabeçalho começa ao lado dele, deixando o conteúdo mais amplo e a navegação mais
      organizada.
    </Paragraph>
    <Paragraph>
      Você pode ativar agora e voltar ao layout atual quando quiser, pelo menu do seu perfil, no
      canto superior direito.
    </Paragraph>
  </Modal>
);
